import { API } from '@/config';

import { HttpClient } from './http';

export const api = new HttpClient({ baseURL: API });
